import { ScrollingProvider } from "react-scroll-section";
import Home from "./Components/Home";
import Technologies from "./Components/Technologies";
import Works from "./Components/Works";
import Contact from "./Components/Contact";
import Navbar from "./Components/Navbar";
import { Suspense } from "react";
import { useState } from "react";
import ResponsiveMenu from "./Components/ResponsiveMenu";
import { Parallax, ParallaxProvider } from "react-scroll-parallax";
import Featured from "./Components/Featured";
import { useEffect } from "react";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    if (window.innerWidth < 1400) {
     
      setMenuOpen(!menuOpen);
    }
  };

  useEffect(() => {
    console.log(window.innerWidth)
  })
  

  return (
    <Suspense fallback={null}>
      <ScrollingProvider>
        <ParallaxProvider>
          {menuOpen && <ResponsiveMenu handleMenuOpen={handleMenuOpen} />}
          <Navbar handleMenuOpen={handleMenuOpen} menuOpen={menuOpen} />
          <Home />
     
          <Parallax
            translateY={[0, 210]}
            speed={10}
            className="blur"
            style={{
              top: "-50%",
              right: "-10%",
              height: "20rem",
              width: "20rem",
              filter: "blur(6rem)",
            }}
          ></Parallax>
          <Featured />
          <Technologies />
          <Parallax
            translateY={[200, 650]}
            speed={4}
            className="blur"
            style={{
              top: "120%",
              left: "15%",
              height: "20rem",
              width: "20rem",
              filter: "blur(6rem)",
            }}
          ></Parallax>
          <Works />
          <Contact />
        </ParallaxProvider>
      </ScrollingProvider>
    </Suspense>
  );
}

export default App;
